
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/one-time-payment",
      function () {
        return require("private-next-pages/one-time-payment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/one-time-payment"])
      });
    }
  